<script>
   /*************************************************************/
   /* AppPlots component for prediction app                     */
   /* -------------------------------                           */
   /* show selection of plot for training of PCA model          */
   /*************************************************************/


   // import locally shared plot and plot controls components
   import AppPlots from '../shared/AppPlots.svelte';
   import VariancePlot from '../shared/VariancePlot.svelte';
   import DistancePlot from '../shared/DistancePlot.svelte';
   import BiPlot from '../shared/BiPlot.svelte';

   import VariancePlotControls from '../shared/VariancePlotControls.svelte';
   import DistancePlotControls from '../shared/DistancePlotControls.svelte';
   import BiPlotControls from '../shared/BiPlotControls.svelte';

   import ScoresPlot from '../../../shared/plots/ScoresPlot.svelte';
   import ScoresPlotControls from '../../../shared/plots/ScoresPlotControls.svelte';

   // input parameters
   export let res;
   export let model;
   export let dataset;

   // array with list of plots and their components
   // parameter "scope" tells parent AppPlots component whether click events must be handled:
   // - for "objects" - it triggers click events on plots as selection of objects and mark them as outliers
   // - for "variables" - it triggers click events on plots as selection of variables (no more actions so far)
   // - for "none" - the click events will be ignored
   const options = [
      {label: 'Scores', scope: 'scores', plotComponent: ScoresPlot, controlsComponent: ScoresPlotControls},
      {label: 'Biplot', scope: 'both', plotComponent: BiPlot, controlsComponent: BiPlotControls},
      {label: 'Variance', scope: 'none', plotComponent: VariancePlot, controlsComponent: VariancePlotControls},
      {label: 'Distances', scope: 'objects', plotComponent: DistancePlot, controlsComponent: DistancePlotControls},
   ]
</script>


<AppPlots on:setoutlier on:plotoutlier {res} {model} {options} {dataset} />